import { HeaderComponent } from 'src/scripts/sections/header'
import { ModalComponent } from '../modal'
import { $el, delay, transitionToPromise } from 'src/scripts/utils/utils'
import { replaceNodeChildren } from 'src/scripts/utils/dom'
import { isMobile } from 'src/scripts/utils/check-media'

const HEADER_SELECTOR = 'header-component'
const HEADER_WITH_POPUP_CLASS = 'shopify-section-header--with-cart-popup'

export class CartNotificationPopup extends ModalComponent {
  wasHeaderHidden: boolean

  purchaseHandler(html, parsedState): void {
    const header: HeaderComponent = $el(HEADER_SELECTOR)
    this.wasHeaderHidden = header.isHidden

    if (this.element) {
      const newNode = $el(`#CartNotificationPopupItem-${parsedState.id}`, html)
      const node = $el('[data-cart-notification-popup]', this.element)

      replaceNodeChildren(node, newNode)

      this.toggleMobileHeader(false).then(() => {
        this.show()

        delay(5000).then(() => {
          this.hide()
        })
      })

      this.emit('update-nodes', { node, parsedState })
    }
  }

  async hide() {
    await super.hide()

    await transitionToPromise(this)
    this.toggleMobileHeader(true)
  }

  toggleMobileHeader = async (isToShow: boolean): Promise<void> => {
    if (isMobile()) {
      const header: HeaderComponent = $el(HEADER_SELECTOR)

      header.parentElement.classList.toggle(HEADER_WITH_POPUP_CLASS, !isToShow)

      if (this.wasHeaderHidden) {
        header.setHidden(isToShow)
      }

      await delay(300)
    }
  }
}
